// Mock data for curriculum plans - SAT V4 Zone
import type { CurriculumPlan, YearGroup } from '../../types';

export const mockCurriculumPlans: CurriculumPlan[] = [
  {
    id: 'curr-y7-2024',
    name: 'Year 7 Curriculum 2024-25',
    yearGroup: 7,
    academicYear: '2024-2025',
    totalPeriodsPerWeek: 30,
    totalPeriodsWeekA: 30,
    totalPeriodsWeekB: 30,
    status: 'active',
    subjects: [
      {
        subjectId: 'subj-eng',
        periodsPerWeek: 5,
        periodsWeekA: 5,
        periodsWeekB: 5,
        isCompulsory: true,
        teacherRequirements: 'English qualified',
      },
      {
        subjectId: 'subj-mat',
        periodsPerWeek: 5,
        periodsWeekA: 5,
        periodsWeekB: 5,
        isCompulsory: true,
        teacherRequirements: 'Mathematics qualified',
      },
      {
        subjectId: 'subj-sci',
        periodsPerWeek: 4,
        periodsWeekA: 4,
        periodsWeekB: 4,
        isCompulsory: true,
        teacherRequirements: 'Science qualified',
      },
      {
        subjectId: 'subj-his',
        periodsPerWeek: 2,
        periodsWeekA: 2,
        periodsWeekB: 2,
        isCompulsory: true,
        teacherRequirements: 'History qualified',
      },
      {
        subjectId: 'subj-geo',
        periodsPerWeek: 2,
        periodsWeekA: 2,
        periodsWeekB: 2,
        isCompulsory: true,
        teacherRequirements: 'Geography qualified',
      },
      {
        subjectId: 'subj-fre',
        periodsPerWeek: 3,
        periodsWeekA: 3,
        periodsWeekB: 3,
        isCompulsory: true,
        teacherRequirements: 'MFL qualified',
      },
      {
        subjectId: 'subj-spa',
        periodsPerWeek: 2,
        periodsWeekA: 2,
        periodsWeekB: 2,
        isCompulsory: false,
        teacherRequirements: 'MFL qualified',
      },
      {
        subjectId: 'subj-art',
        periodsPerWeek: 2,
        periodsWeekA: 2,
        periodsWeekB: 2,
        isCompulsory: false,
        teacherRequirements: 'Art qualified',
      },
      {
        subjectId: 'subj-mus',
        periodsPerWeek: 2,
        periodsWeekA: 2,
        periodsWeekB: 2,
        isCompulsory: false,
        teacherRequirements: 'Music qualified',
      },
      {
        subjectId: 'subj-dra',
        periodsPerWeek: 1,
        periodsWeekA: 1,
        periodsWeekB: 1,
        isCompulsory: false,
        teacherRequirements: 'Drama qualified',
      },
      {
        subjectId: 'subj-pe',
        periodsPerWeek: 2,
        periodsWeekA: 2,
        periodsWeekB: 2,
        isCompulsory: true,
        teacherRequirements: 'PE qualified',
      },
    ],
  },
  {
    id: 'curr-y8-2024',
    name: 'Year 8 Curriculum 2024-25',
    yearGroup: 8,
    academicYear: '2024-2025',
    totalPeriodsPerWeek: 30,
    totalPeriodsWeekA: 30,
    totalPeriodsWeekB: 30,
    status: 'active',
    subjects: [
      {
        subjectId: 'subj-eng',
        periodsPerWeek: 5,
        periodsWeekA: 5,
        periodsWeekB: 5,
        isCompulsory: true,
        teacherRequirements: 'English qualified',
      },
      {
        subjectId: 'subj-mat',
        periodsPerWeek: 5,
        periodsWeekA: 5,
        periodsWeekB: 5,
        isCompulsory: true,
        teacherRequirements: 'Mathematics qualified',
      },
      {
        subjectId: 'subj-sci',
        periodsPerWeek: 4,
        periodsWeekA: 4,
        periodsWeekB: 4,
        isCompulsory: true,
        teacherRequirements: 'Science qualified',
      },
      {
        subjectId: 'subj-his',
        periodsPerWeek: 2,
        periodsWeekA: 2,
        periodsWeekB: 2,
        isCompulsory: true,
        teacherRequirements: 'History qualified',
      },
      {
        subjectId: 'subj-geo',
        periodsPerWeek: 2,
        periodsWeekA: 2,
        periodsWeekB: 2,
        isCompulsory: true,
        teacherRequirements: 'Geography qualified',
      },
      {
        subjectId: 'subj-fre',
        periodsPerWeek: 3,
        periodsWeekA: 3,
        periodsWeekB: 3,
        isCompulsory: true,
        teacherRequirements: 'MFL qualified',
      },
      {
        subjectId: 'subj-spa',
        periodsPerWeek: 2,
        periodsWeekA: 2,
        periodsWeekB: 2,
        isCompulsory: false,
        teacherRequirements: 'MFL qualified',
      },
      {
        subjectId: 'subj-art',
        periodsPerWeek: 2,
        periodsWeekA: 2,
        periodsWeekB: 2,
        isCompulsory: false,
        teacherRequirements: 'Art qualified',
      },
      {
        subjectId: 'subj-mus',
        periodsPerWeek: 2,
        periodsWeekA: 2,
        periodsWeekB: 2,
        isCompulsory: false,
        teacherRequirements: 'Music qualified',
      },
      {
        subjectId: 'subj-dra',
        periodsPerWeek: 1,
        periodsWeekA: 1,
        periodsWeekB: 1,
        isCompulsory: false,
        teacherRequirements: 'Drama qualified',
      },
      {
        subjectId: 'subj-pe',
        periodsPerWeek: 2,
        periodsWeekA: 2,
        periodsWeekB: 2,
        isCompulsory: true,
        teacherRequirements: 'PE qualified',
      },
    ],
  },
  {
    id: 'curr-y9-2024',
    name: 'Year 9 Curriculum 2024-25',
    yearGroup: 9,
    academicYear: '2024-2025',
    totalPeriodsPerWeek: 30,
    totalPeriodsWeekA: 30,
    totalPeriodsWeekB: 30,
    status: 'active',
    subjects: [
      {
        subjectId: 'subj-eng',
        periodsPerWeek: 5,
        periodsWeekA: 5,
        periodsWeekB: 5,
        isCompulsory: true,
        teacherRequirements: 'English qualified',
      },
      {
        subjectId: 'subj-mat',
        periodsPerWeek: 5,
        periodsWeekA: 5,
        periodsWeekB: 5,
        isCompulsory: true,
        teacherRequirements: 'Mathematics qualified',
      },
      {
        subjectId: 'subj-sci',
        periodsPerWeek: 4,
        periodsWeekA: 4,
        periodsWeekB: 4,
        isCompulsory: true,
        teacherRequirements: 'Science qualified',
      },
      {
        subjectId: 'subj-his',
        periodsPerWeek: 2,
        periodsWeekA: 2,
        periodsWeekB: 2,
        isCompulsory: true,
        teacherRequirements: 'History qualified',
      },
      {
        subjectId: 'subj-geo',
        periodsPerWeek: 2,
        periodsWeekA: 2,
        periodsWeekB: 2,
        isCompulsory: true,
        teacherRequirements: 'Geography qualified',
      },
      {
        subjectId: 'subj-fre',
        periodsPerWeek: 3,
        periodsWeekA: 3,
        periodsWeekB: 3,
        isCompulsory: true,
        teacherRequirements: 'MFL qualified',
      },
      {
        subjectId: 'subj-ict',
        periodsPerWeek: 2,
        periodsWeekA: 2,
        periodsWeekB: 2,
        isCompulsory: false,
        teacherRequirements: 'ICT qualified',
      },
      {
        subjectId: 'subj-dt',
        periodsPerWeek: 2,
        periodsWeekA: 2,
        periodsWeekB: 2,
        isCompulsory: false,
        teacherRequirements: 'DT qualified',
      },
      {
        subjectId: 'subj-mus',
        periodsPerWeek: 1,
        periodsWeekA: 1,
        periodsWeekB: 1,
        isCompulsory: false,
        teacherRequirements: 'Music qualified',
      },
      {
        subjectId: 'subj-dra',
        periodsPerWeek: 1,
        periodsWeekA: 1,
        periodsWeekB: 1,
        isCompulsory: false,
        teacherRequirements: 'Drama qualified',
      },
      {
        subjectId: 'subj-pe',
        periodsPerWeek: 2,
        periodsWeekA: 2,
        periodsWeekB: 2,
        isCompulsory: true,
        teacherRequirements: 'PE qualified',
      },
      {
        subjectId: 'subj-rs',
        periodsPerWeek: 1,
        periodsWeekA: 1,
        periodsWeekB: 1,
        isCompulsory: true,
        teacherRequirements: 'RS qualified',
      },
    ],
  },
  {
    id: 'curr-y10-2024',
    name: 'Year 10 Curriculum 2024-25 (GCSE)',
    yearGroup: 10,
    academicYear: '2024-2025',
    totalPeriodsPerWeek: 30,
    totalPeriodsWeekA: 30,
    totalPeriodsWeekB: 30,
    status: 'active',
    subjects: [
      {
        subjectId: 'subj-eng',
        periodsPerWeek: 5,
        periodsWeekA: 5,
        periodsWeekB: 5,
        isCompulsory: true,
        teacherRequirements: 'English qualified',
      },
      {
        subjectId: 'subj-mat',
        periodsPerWeek: 5,
        periodsWeekA: 5,
        periodsWeekB: 5,
        isCompulsory: true,
        teacherRequirements: 'Mathematics qualified',
      },
      {
        subjectId: 'subj-phy',
        periodsPerWeek: 3,
        periodsWeekA: 3,
        periodsWeekB: 3,
        isCompulsory: false,
        teacherRequirements: 'Physics qualified',
      },
      {
        subjectId: 'subj-che',
        periodsPerWeek: 3,
        periodsWeekA: 3,
        periodsWeekB: 3,
        isCompulsory: false,
        teacherRequirements: 'Chemistry qualified',
      },
      {
        subjectId: 'subj-bio',
        periodsPerWeek: 3,
        periodsWeekA: 3,
        periodsWeekB: 3,
        isCompulsory: false,
        teacherRequirements: 'Biology qualified',
      },
      {
        subjectId: 'subj-his',
        periodsPerWeek: 3,
        periodsWeekA: 3,
        periodsWeekB: 3,
        isCompulsory: false,
        teacherRequirements: 'History qualified',
      },
      {
        subjectId: 'subj-geo',
        periodsPerWeek: 3,
        periodsWeekA: 3,
        periodsWeekB: 3,
        isCompulsory: false,
        teacherRequirements: 'Geography qualified',
      },
      {
        subjectId: 'subj-fre',
        periodsPerWeek: 3,
        periodsWeekA: 3,
        periodsWeekB: 3,
        isCompulsory: false,
        teacherRequirements: 'MFL qualified',
      },
      {
        subjectId: 'subj-pe',
        periodsPerWeek: 2,
        periodsWeekA: 2,
        periodsWeekB: 2,
        isCompulsory: true,
        teacherRequirements: 'PE qualified',
      },
      {
        subjectId: 'subj-rs',
        periodsPerWeek: 2,
        periodsWeekA: 2,
        periodsWeekB: 2,
        isCompulsory: true,
        teacherRequirements: 'RS qualified',
      },
    ],
  },
  {
    id: 'curr-y11-2024',
    name: 'Year 11 Curriculum 2024-25 (GCSE)',
    yearGroup: 11,
    academicYear: '2024-2025',
    totalPeriodsPerWeek: 30,
    totalPeriodsWeekA: 30,
    totalPeriodsWeekB: 30,
    status: 'active',
    subjects: [
      {
        subjectId: 'subj-eng',
        periodsPerWeek: 5,
        periodsWeekA: 5,
        periodsWeekB: 5,
        isCompulsory: true,
        teacherRequirements: 'English qualified',
      },
      {
        subjectId: 'subj-mat',
        periodsPerWeek: 5,
        periodsWeekA: 5,
        periodsWeekB: 5,
        isCompulsory: true,
        teacherRequirements: 'Mathematics qualified',
      },
      {
        subjectId: 'subj-phy',
        periodsPerWeek: 3,
        periodsWeekA: 3,
        periodsWeekB: 3,
        isCompulsory: false,
        teacherRequirements: 'Physics qualified',
      },
      {
        subjectId: 'subj-che',
        periodsPerWeek: 3,
        periodsWeekA: 3,
        periodsWeekB: 3,
        isCompulsory: false,
        teacherRequirements: 'Chemistry qualified',
      },
      {
        subjectId: 'subj-bio',
        periodsPerWeek: 3,
        periodsWeekA: 3,
        periodsWeekB: 3,
        isCompulsory: false,
        teacherRequirements: 'Biology qualified',
      },
      {
        subjectId: 'subj-his',
        periodsPerWeek: 3,
        periodsWeekA: 3,
        periodsWeekB: 3,
        isCompulsory: false,
        teacherRequirements: 'History qualified',
      },
      {
        subjectId: 'subj-geo',
        periodsPerWeek: 3,
        periodsWeekA: 3,
        periodsWeekB: 3,
        isCompulsory: false,
        teacherRequirements: 'Geography qualified',
      },
      {
        subjectId: 'subj-fre',
        periodsPerWeek: 3,
        periodsWeekA: 3,
        periodsWeekB: 3,
        isCompulsory: false,
        teacherRequirements: 'MFL qualified',
      },
      {
        subjectId: 'subj-pe',
        periodsPerWeek: 2,
        periodsWeekA: 2,
        periodsWeekB: 2,
        isCompulsory: true,
        teacherRequirements: 'PE qualified',
      },
      {
        subjectId: 'subj-rs',
        periodsPerWeek: 2,
        periodsWeekA: 2,
        periodsWeekB: 2,
        isCompulsory: true,
        teacherRequirements: 'RS qualified',
      },
    ],
  },
];

export default mockCurriculumPlans;
